var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button__webshop fixed z-4 top-vh-100-circle right-0"},[_c('a',{ref:`ButtonCircleRotating`,staticClass:"db btn-circle",class:_vm.darkTheme == 'dark' ? 'dark' : 'white',attrs:{"href":_vm.shop.url}},[_vm._v(_vm._s(_vm.shop.buttonLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }